module.exports = __webpack_public_path__ + "static/img/icon7.013187be.svg";